<div class="d-flex justify-content-center h-100 my-md-5">
    <div class="col-sm-5 p-2" *ngIf="isShowCard('card1')">
        <div class="card card-1 border border-primary p-1 z-depth-1">
            <div class="card-body text-center">
                <h5 class="card-title">Hello {{getUser().name}}!</h5>
                <p class="card-text">
                    Before starting we need you to fill some data to help you get better matches
                </p>
                <gb-action-button (onClick)="showChoiceCard()" [text]="'Go'"></gb-action-button>
            </div>
        </div>
    </div>
    <div class="col-sm-5 p-2" *ngIf="isShowCard('card2')">
        <div class="card card-2 animated slideInDown border border-primary p-1 z-depth-1 text-center">
            <div class="card-body">
                <p class="card-text mt-2">
                    Mark the problems you have struggled with recently:

                </p>
                <div class="md-form">
                    <input mdbInput type="text" (keyup)="filterDisorders($event)" class="form-control w-25 mx-auto text-center" placeholder="Filter">
                </div>
                <div class="tags-container m-3 pt-2 pb-1">
                    <div class="d-inline" *ngFor="let d of disordersSetup; let i = index">
                        <mdb-badge [hidden]="d.hide" *ngIf="d.key !=='LONELINESS'" (click)="mark(d)" class="dbadge m-1 animated rotateIn" [ngClass]="{ 'warning-color' :d.isSelected,'grey lighten-1' :!d.isSelected, 'rotateInDownLeft': (i % 2) === 0 , 'rotateInUpLeft': (i%2) === 1}"
                            pill="true">{{d.value}}</mdb-badge>
                    </div>
                </div>
                <gb-action-button (onClick)="setUpUser()" [isLoading]="isSetupLoading" [whenDisabled]="getSelectedDisorders().length === 0" [text]="'Done'" [iconClass]="'check'"></gb-action-button>
            </div>
        </div>
    </div>

    <div class="card-center p-2" *ngIf="isShowCard('card3')">
        <div class="card card-2 animated slideInDown border border-primary p-1 z-depth-1 text-center">
            <div class="card-body">
                <p class="card-text mt-2">
                    Would you like to upload your profile picture?
                </p>
                <div class="container position-relative" *ngIf="!showCropper && croppedImage">
                    <div class="position-relative d-inline-block p-3">
                        <mdb-icon fas icon="pen" (click)="showCropper = true" class="edit fa-md m-2"></mdb-icon>
                        <img class="profile-photo animated rollIn" [src]="croppedImage">
                    </div>
                </div>

                <div class="avatar-container m-3 pt-2 pb-1">
                    <div class="custom-file mb-2">
                        <input type="file" accept="image/*" class="custom-file-input" id="customFile" (change)="handleFileInput($event)">
                        <label class="custom-file-label text-left" for="customFile">{{file ? file.name : "Choose file"}}</label>
                    </div>
                    <gb-action-button (onClick)="uploadAvatar()" [isLoading]="isAvatarLoading" [whenDisabled]="!croppedImage" [text]="'Upload'" [iconClass]="'cloud-upload-alt'"></gb-action-button>
                    <a class="my-2 d-block text-dark" (click)="skipAvatar()">Skip</a>
                </div>
            </div>
        </div>
    </div>

    <div class="card-center p-2" *ngIf="isShowCard('card4')">
        <div class="card card-2 animated slideInDown border border-primary p-1 z-depth-1 text-center">
            <div class="card-body">
                <p class="card-text mt-2">
                    Want to say something important to other users? Set profile message:
                </p>
                <div class="text-muted small"><em>ex. "Not looking for an advice. Just want to chat"</em></div>
                <div class="md-form">
                    <input #statusInput mdbInput type="text" class="form-control w-75 mx-auto" placeholder="Your message">
                </div>
                <div class="avatar-container m-3 pt-2 pb-1">
                    <gb-action-button (onClick)="setStatusMessage()" [isLoading]="statusLoad" [whenDisabled]="getStatusMessage().length === 0" [text]="'Set'" [iconClass]="'check'"></gb-action-button>
                    <a class="my-2 d-block text-dark" (click)="skipStatusMessage()">Skip</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="overlay" *ngIf="showCropper">
    <div class="row mx-1">
        <div class="col-md-3"></div>
        <div class="col-md-6 cropper-container my-md-5 border border-primary">
            <image-cropper format="jpeg" [roundCropper]="true" (imageCropped)="imageCropped($event)" [imageChangedEvent]="imageChangedEvent"></image-cropper>
            <div class="preview text-center p-2">
                <img class="profile-photo animated rollIn" *ngIf="croppedImage" [src]="croppedImage">
            </div>
            <div class="text-center">
                <gb-action-button (onClick)="showCropper = false" [text]="'Crop'" [iconClass]="'cut'"></gb-action-button>
            </div>
        </div>
        <div class="col-md-3"></div>
    </div>
</div>